export default {
  "cat.shoes": "Sapatos",
  "cat.hoodies": "Moletons / Suéteres",
  "cat.tshirts": "Camisetas",
  "cat.jackets": "Jaquetas",
  "cat.pants": "Calças / Shorts",
  "cat.headwear": "Chapéus",
  "cat.sets": "Conjuntos",
  "cat.underwear": "Roupa íntima",
  "cat.jersey": "Camisas esportivas",
  "cat.accessories": "Acessórios",
  "cat.bags": "Bolsas",
  "cat.belts": "Cintos",
  "cat.perfumes": "Perfumes",
  "cat.other": "Outros itens",
};